export type SettlementStatsFilters = {
  publisher_id?: number;
};

export const cleanFilters = (
  filters: SettlementStatsFilters
): Record<string, number> => {
  const out: Record<string, number> = {};
  if (filters.publisher_id != null) {
    out.publisher_id = filters.publisher_id;
  }
  return out;
};
